import { useContext } from "react";
import { FundListContext } from "../context";

export const useFundList = () => useContext(FundListContext);
